import React from 'react';
import { Col } from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';

class InputSelect extends AbstractComponent {
    constructor(props) {
        super(props);
        this.id = this.props.id || this.props.nome;
    }

    classErro() {
        return this.props.erro !== undefined && this.props.erro !== '' ? 'form-controll-erro' : '';
    }    

    erro() {
        if(Array.isArray(this.props.erro)) {
            return(
                <ul>
                    {this.props.erro.map( (item , i) => {
                        return (
                            <li key={i}>{item}</li>
                        )
                    })}
                </ul>
            )
        }

        return this.props.erro;
    } 

    onChangeSelect(input) {        
        if(this.props.onChange !== undefined) {
            this.props.onChange(input);
        }
    }    

    classNameInput() {
        return this.props.classNameInput !== undefined ? this.props.classNameInput : '';
    }

    onBlur(blur) {
        if (this.props.onBlur !== undefined) {
            this.props.onBlur(blur);
        }
    }    

    render() {
        return (
            <Col lg={this.props.lg} 
                 md={this.props.md} 
                 sm={this.props.sm} 
                 xs={this.props.xs}>
                <div className={this.classErro()}>
                    <label htmlFor={this.props.nome}>
                        {this.props.children}
                    </label>                                     

                    <select                        
                        value={this.props.value}                        
                        className={"form-control " + this.classNameInput()}
                        name={this.props.nome}
                        id={this.nome}
                        onChange={input => this.onChangeSelect(input)}
                        onBlur={blur => this.onBlur(blur)}
                        onKeyPress={e => (this.props.onKeyPress !== undefined) ? this.props.onKeyPress(e) : ''}
                        disabled={this.props.disabled}>
                        {
                            this.props.options.map((option, i) => {
                                return (
                                    <option 
                                        key={i} 
                                        value={option[this.props.valor]}                                        
                                    >
                                        {option[this.props.texto]}
                                    </option>
                                )
                            })
                        }
                    </select>

                    <span className="help-block">
                        {this.erro()}
                    </span>
                </div>
            </Col>
        )
    }
}

InputSelect.defaultProps = {
    md: '12',
    customClassComponent: '',
    valor: 'valor',
    texto: 'texto'
};

export default InputSelect;